// @ts-nocheck
/* Starter Sync - MyListsDetailsPage */

import siteMessage from "@insite/client-framework/SiteMessage";
import activateInvite from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ActivateInvite";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useWishListState } from "@toolkit/Framework/Store/Data/MyLists/MyListsHooks";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

export interface MyListsDetailsPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
    errorInfosBox?: InfosBoxProps;
}

export const myListsDetailsPageContainerStyles: MyListsDetailsPageContainerStyles = {
    errorInfosBox: { type: "error" },
};

const mapDispatchToProps = {
    activateInvite,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

const styles = myListsDetailsPageContainerStyles;

const MyListsDetailsPageContainer: FC<Props> = ({ id: widgetId, activateInvite }) => {
    const history = useHistory();
    const location = useLocation();
    const { id, invite } = useQueryString();
    const wishlistDataView = useWishListState(id);
    const [inviteIsNotAvailable, setInviteIsNotAvailable] = useState(false);

    if (invite) {
        activateInvite({
            invite,
            onSuccess: wishList => {
                history.replace(`${location.pathname}?id=${wishList.id}`);
            },
            onError: () => {
                setInviteIsNotAvailable(true);
            },
            onComplete(wishListProps) {
                if (wishListProps.result?.wishList) {
                    this.onSuccess?.(wishListProps.result.wishList);
                } else if (wishListProps.result?.errorMessage !== undefined) {
                    // possible empty string error here
                    this.onError?.(wishListProps.result.errorMessage);
                }
            },
        });
    }

    return (
        <DataViewLoadingOverlay dataView={wishlistDataView} {...styles.loadingOverlay}>
            {inviteIsNotAvailable || wishlistDataView.errorStatusCode === 404 ? (
                <InfosBox {...styles.errorInfosBox}>
                    {inviteIsNotAvailable
                        ? siteMessage("Lists_InviteIsNotAvailable")
                        : siteMessage("Lists_List_NotFound")}
                </InfosBox>
            ) : (
                <OrderLayout id={widgetId} />
            )}
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(MyListsDetailsPageContainer),
    definition: {
        displayName: "Page Container",
        group: "My Lists Details",
        allowedContexts: ["MyListsDetailsPage"],
    },
};
export default widgetModule;
